import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface GodDto {
	id: string;
	pantheonId: string;
	pantheonName?: string | null;
	name: string;
	description?: string | null;
	gmNotes?: string | null;
	imageAssetId?: string | null;
	foundryId?: string | null;
	domains?: Array<{ id: string; name: string | null }>;
	domainIds?: string[];
	updatedAt: string;
	createdAt: string;
}

export interface GodsListResponse {
	gods: GodDto[];
	total: number;
}

export interface GodGetResponse {
	god: GodDto;
}

export interface UpsertGodRequest {
	pantheonId: string;
	name: string;
	description?: string | null;
	gmNotes?: string | null;
	imageAssetId?: string | null;
	domainIds?: string[];
	foundryId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class GodsService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string, q?: string): Observable<GodsListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (q) params = params.set('q', q);
		return this.http.get<GodsListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/gods`, { params });
	}

	get(worldId: string, godId: string): Observable<GodGetResponse> {
		return this.http.get<GodGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/gods/${godId}`);
	}

	create(worldId: string, request: UpsertGodRequest): Observable<GodGetResponse> {
		return this.http.post<GodGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/gods`, {
			PantheonId: request.pantheonId,
			Name: request.name,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			DomainIds: request.domainIds ?? [],
			FoundryId: request.foundryId ?? null,
		});
	}

	update(worldId: string, godId: string, request: UpsertGodRequest): Observable<GodGetResponse> {
		return this.http.put<GodGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/gods/${godId}`, {
			PantheonId: request.pantheonId,
			Name: request.name,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			DomainIds: request.domainIds ?? [],
			FoundryId: request.foundryId ?? null,
		});
	}

	delete(worldId: string, godId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/gods/${godId}`);
	}
}
